import { Select, SelectProps } from "@chakra-ui/react";
import { Account } from "common";
import { useEffect, useMemo } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";

interface AccountSelectorProps extends SelectProps {
  account: Account | null;
  setAccount: (account: Account | null) => void;
  filterAccount?: (account: Account) => boolean;
}

export const AccountSelector = ({
  account,
  setAccount,
  filterAccount,
  ...selectProps
}: AccountSelectorProps) => {
  const api = useAPI();
  const { data, error, query } = useAPIQuery({ apiCall: api.accountGet });
  useToastOnAPIError({
    error: error,
    title: `Unable to fetch Leaders`,
  });
  const accounts = useMemo(
    () =>
      data?.accounts?.filter((account) =>
        filterAccount ? filterAccount(account) : true
      ) ?? [],
    [data?.accounts, filterAccount]
  );

  useEffect(() => {
    query({});
  }, [query]);

  return (
    <Select
      placeholder={"Select Account"}
      value={account ? account.id : ""}
      onChange={(e) =>
        setAccount(accounts.find((a) => `${a.id}` === e.target.value) ?? null)
      }
      {...selectProps}
    >
      {accounts.map((account) => (
        <option key={account.id} value={account.id}>
          {account.fName} {account.lName}
        </option>
      ))}
    </Select>
  );
};
